import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { BookQuizComponent } from './components/BookQuizComponent';
import ErrorMessageBox from '../components/ErrorMessageBox';
import { Loading } from '../components/Loading';
import { scrollToElement } from '../../lib/userFunctions';
import { createFetchErrorMessage } from 'utils/api/ApiClient';
import { useQuery } from '@tanstack/react-query';
import Api from 'utils/api/Api';



const BookQuiz = ()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const auth = useSelector(state => state.auth);
    const [isComplete, setIsComplete] = useState(false);
    
    const bookQuiz = useQuery({
        queryKey:['quiz', isbn],
        queryFn:()=>Api.get(`/api/quiz/quiz-start?isbn=${isbn}`),
        retry:false,
        refetchOnMount:'always',
    });

    useEffect(() => {
        scrollToElement('lnb');
    }, [dispatch]);
    
    function gotoMyReading(){
        navigate(`/${school}/user`);
    }

    function onQuizComplete()
    {
        setIsComplete(true);
        _.delay(gotoMyReading, 1000);
    }

  
    if(bookQuiz.isLoading)return <Loading />;
    if(bookQuiz.isError) return <ErrorMessageBox message={createFetchErrorMessage(bookQuiz.error).message} />;
    
    if(bookQuiz?.data?.data?.quizList?.length===0){
        return <div className="no_data"><p>퀴즈가 없습니다.</p></div>;
    }

    return(
        <div className="section _bg bdT0 quiz">
            <div className="inner">
                { !isComplete && 
                    <div>
                        <BookQuizComponent quizData={bookQuiz?.data?.data} auth={auth}
                                    onQuizComplete={onQuizComplete} />
                    </div>
                }
                { isComplete && 
                    <img src={`${process.env.PUBLIC_URL}/images/common/goodjob.gif`}  alt="잘했어요 Good"></img> 
                }
            </div>
        </div>
    );
}//end
export default BookQuiz;